import { VSelectItem } from "@/core/interfaces/v-select.interface";
import { Specialization } from "@/core/references/specializations/specialization.interface";
import { AxiosInstance } from "axios";

export class SpecializationsReference {
  #list: Specialization[] = [];

  constructor(private http: AxiosInstance) {}

  async getList(name = ""): Promise<Specialization[]> {
    try {
      const { data } = await this.http.get(`/v1/references/specializations`, {
        params: { name },
      });
      this.#list = data?.data || [];

      return this.#list;
    } catch (e) {
      console.log(e.response);
    }

    return [];
  }

  async getByCode(id: string): Promise<Specialization | null> {
    try {
      const { data } = await this.http.get(`/v1/references/specializations/${id}`);
      return data?.data;
    } catch (e) {
      console.log(e.response);
    }

    return null;
  }

  getSelectItems(): VSelectItem[] {
    return this.#list.map((item) => ({
      text: item.name,
      value: item.id,
    }));
  }

  getDoctorSelectItems(): VSelectItem[] {
    return this.#list.map((item) => ({
      text: item?.doctor_name || item.name,
      value: item.id,
    }));
  }
}
